<template lang="pug">
	.lexicon--editor-popup.flex-col
		DxButton(v-if="!UIHidden", icon="edit", @click="show")
		Popup(v-if="popupVisible", :popupVisible="popupVisible", :width="720", :height="height || 540", :title="lexiconBO.LexiconType === 0 ? $tCaption('Lexicon editor') : $tCaption('Custom TN editor')")
			.flex-col.space-large
				slot
				template(v-if="lexiconBO")
					LexiconEditor(v-if="lexiconBO.LexiconType === 0", ref="lexicon", :value="value", :url="url", :scrollHeight="scrollHeight", :lexiconName="lexiconName", @change="onLexiconChange", :lexiconBO="lexiconBO")
					CustomTNEditor(v-else, ref="lexicon", :value="value", :url="url", :scrollHeight="scrollHeight", :lexiconName="lexiconName", @change="onLexiconChange", :lexiconBO="lexiconBO")
			template(slot="actions-left")
				template(v-if="lexiconBO")
					DxButton(:text="lexiconBO.LexiconType === 0 ? $tCaption('Download XML') : $tCaption('Download JSON')", @click="$refs.lexicon.download()", icon="download")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="cancel")
				DxButton(:text="$tCaption('Save', '@actions')", type="default", @click="save", :disabled="allowSave !== void 0 && !allowSave")
</template>

<script>
	import Popup from 'app-core/Popup.vue';
	import DxButton from 'devextreme-vue/button';
	import LexiconEditor from './LexiconEditor.vue';
	import CustomTNEditor from './CustomTNEditor.vue';

	export default {
		translationCategory: 'lexicon.LexiconEditor',
		name: 'lexicon--editor.',
		props: ['value', 'url', 'UIHidden', 'allowSave', 'scrollHeight', 'height', 'lexiconName', 'lexiconBO'],
		components: { Popup, DxButton, LexiconEditor, CustomTNEditor },
		data() {
			return {
				popupVisible: false,
				lexicon: null
			};
		},
		mounted() {
		},
		methods: {
			show(opts) {
				if (__DEBUG__)
					window.lexiconEditorPopup = this;
				this.popupVisible = false;
				this.$nextTick(() => {
					this.popupVisible = true;
					setImmediate(async () => {
						if (opts?.addPhonemeToLexicon) {
							await this.$refs.lexicon.loadLexicon();
							this.$refs.lexicon.addPhoneme({
								grapheme: opts?.addPhonemeToLexicon
							});
						}
					});
				});
			},
			save() {
				this.popupVisible = false;
				this.$emit('save', this.lexicon);
			},
			cancel() {
				this.popupVisible = false;
				this.$emit('cancel', this.lexicon);
			},
			onLexiconChange(lexicon) {
				if (__DEBUG__)
					console.debug('onLexiconChange', { lexicon });
				this.lexicon = lexicon;
			}
		}
	};
</script>
<style lang='scss'>
	.lexicon--editor-popup {
		
	}
</style>
